import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { externalLink } from '../../../../../configs/externalLink'
import { languages } from '../../../../../configs/language'
import { ExternalLink } from '../../../ExternalLink'
import { Element } from '../../../html/element'
import { Icon } from '../../../html/icon'
import { Loading } from '../../../loading'
import { Notification } from '../../../notification'
import { SelectCustom } from '../../../selectCustom'
import { TYPE_OF_FT_OPTIONS, factSheetTypes } from '../constants'
import {
  changeFsType,
  selectData,
  selectDataAvailabilityDetails,
  selectFsType,
  selectIsLoadingDataAvailability,
  selectSource,
} from '../store/slice'
import { getDataAvailability } from '../store/thunk'
import useGetOrganizationId from '../useGetOrganizationId'
import { AvailableData } from './AvailableData'
import { SourceSelect } from './SourceSelect'
import { TableContent } from './TableContent'
import classes from './TableSelect.module.scss'
import { LINK_FS_EN, LINK_FS_VI } from './constant'

export const TableSelect = ({ type, orgId, isHiddenPrice }) => {
  const dispatch = useDispatch()

  const organizationId = useGetOrganizationId(orgId)

  const isLoadingDataAvailability = useSelector(selectIsLoadingDataAvailability)
  const availabilityDetails = useSelector(selectDataAvailabilityDetails)
  const data = useSelector(selectData)
  const source = useSelector(selectSource)
  const fsType = useSelector(selectFsType)
  const locale = useSelector((state) => state.i18n.locale)

  const getFactSheetTypeOfFt = () => {
    return TYPE_OF_FT_OPTIONS.find((item) => item.value === fsType) || {}
  }

  const onSelectType = (item) => {
    dispatch(changeFsType(item.value))
    dispatch(
      getDataAvailability({
        organizationId,
        sourceOrganizationId: source,
        isConsolidated: item.value,
      }),
    )
  }

  const resetFilter = () => {
    dispatch(getDataAvailability({ organizationId }))
  }

  const goToFs = () => {
    window.open(locale === languages.en ? LINK_FS_EN : LINK_FS_VI)
  }

  const renderHeader = (children) => {
    return (
      <div className="dFlex justifyContentBetween alignItemsCenter">
        {children}
        <Element
          style={{ color: '#2c73e8', backgroundColor: '#c8e3ff' }}
          className={classes.resetFilter}
          onClick={resetFilter}
        >
          <Icon className="icon-reset2" style={{ marginRight: 4 }} />
          <Translate value="financialStatement.RESET_FILTER" />
        </Element>
      </div>
    )
  }

  const renderContent = (isHidePopupSetting = false) => {
    if (!data.availableData) {
      return <Notification />
    }

    return (
      <>
        <div className={classes.filterSelect}>
          {!isHidePopupSetting && (
            <div className={classes.mb4}>
              <ExternalLink href={externalLink.HOW_TO_SETTING_FS[locale]}>
                <Translate value="domesticSearchPreview.HOW_TO_SET_YOUR_FT" />
              </ExternalLink>
            </div>
          )}
          <div className="dFlex">
            <div className="flexColumn">
              <div
                className={[classes.titleFilterSelect, classes.mb4].join(' ')}
              >
                <Translate value="domesticSearchPreview.SOURCE" />
              </div>
              <div
                className={[classes.titleFilterSelect, classes.mb4].join(' ')}
              >
                <Translate value="domesticSearchPreview.TYPE_OF_FT" />
              </div>
            </div>
            <div className="flexColumn">
              <div className={classes.mb4}>
                <SourceSelect orgId={orgId} />
              </div>
              <div className={classes.mb4}>
                <SelectCustom
                  zIndex={13}
                  className="mx2"
                  activeItem={getFactSheetTypeOfFt()}
                  data={TYPE_OF_FT_OPTIONS}
                  chooseItem={onSelectType}
                  isI18n
                  isNoWrap
                />
              </div>
            </div>
          </div>
        </div>
        <div className="positionRelative">
          {isLoadingDataAvailability && <Loading />}
          <div style={{ opacity: isLoadingDataAvailability ? 0 : 1 }}>
            {availabilityDetails.length ? (
              <TableContent orgId={orgId} />
            ) : type === factSheetTypes.POPUP_LITE ? (
              <Element
                style={{ backgroundColor: '#FFFFFF' }}
                className="p1 my1"
              >
                <Notification />
              </Element>
            ) : (
              <Notification />
            )}
          </div>
        </div>
      </>
    )
  }

  if (type === factSheetTypes.POPUP_OTHERS) {
    return (
      <Element className={classes.p12} style={{ backgroundColor: '#FFFFFF' }}>
        {renderHeader(
          <div>
            {!isHiddenPrice && (
              <div className={classes.mb4}>
                <Translate
                  value="common.order.factSheet.FS_SETTINGS"
                  className="fw600"
                />
              </div>
            )}
            {data.availableData && (
              <div className={`${classes.mb4} ${classes.pl20}`}>
                <AvailableData />
              </div>
            )}
          </div>,
        )}
        <div className="px1">{renderContent()}</div>
      </Element>
    )
  }

  if (type === factSheetTypes.POPUP_LITE) {
    return (
      <>
        <Element style={{ backgroundColor: '#FFFFFF' }} className="mt1">
          <div className="px3 py1">
            {renderHeader(
              <div className={classes.pl12}>
                <AvailableData />
              </div>,
            )}
            {renderContent()}
          </div>
        </Element>
      </>
    )
  }

  if (type === factSheetTypes.SETTING_DYNAMIC_REPORT) {
    return (
      <div className={classes.px24py4}>
        {renderHeader(
          <div className={classes.pl12}>
            <div className={classes.mb4}>
              <AvailableData />
            </div>
            <div className={classes.mb4}>
              <Element
                elementName="span"
                style={{ color: '#2C73E8' }}
                className="cursorPointer"
                onClick={goToFs}
              >
                <Translate value="domesticSearchPreview.HOW_TO_SET_YOUR_FT" />
              </Element>
            </div>
          </div>,
        )}
        <div>{renderContent(true)}</div>
      </div>
    )
  }

  return (
    <div
      className={`${classes.px24py12} ${classes.mt12}`}
      style={{ backgroundColor: '#FFFFFF' }}
    >
      {renderHeader(
        <div className={classes.mb4}>
          <AvailableData />
        </div>,
      )}
      <div>{renderContent()}</div>
    </div>
  )
}
